import { reportRoomExposure } from "_api/room/index";

const opt = {
  root: null, //默认浏览器视窗
  threshold: 0.5, //元素出现一半时触发。
};

// 曝光房间列表累积的长度阈值，超过立马进行上报
const SHOULD_REPORT_COUNT = 50;

class ExposureHandler {
  constructor(options) {
    this.exposureRooms = [];

    this.timer = null;

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          // 防止vue组件切换时触发
          if (
            entry.target &&
            entry.target._exposure_value &&
            entry.boundingClientRect &&
            !(
              entry.boundingClientRect.width +
                entry.boundingClientRect.height ===
              0
            ) &&
            entry.intersectionRect &&
            !(
              entry.intersectionRect.width + entry.intersectionRect.height ===
              0
            )
          ) {
            observer.unobserve(entry.target);
            if (!this.exposureRooms.includes(entry.target._exposure_value)) {
              this.addRoom = entry.target._exposure_value;
            }
          }
        });
      },
      {
        ...opt,
        ...options,
      }
    );

    this.initEventListener();
  }

  /**
   * 添加曝光的房间，到列表中
   */
  set addRoom(val) {
    this.exposureRooms.push(val);
    if (this.exposureRooms.length >= SHOULD_REPORT_COUNT) {
      this.uploadExposureRooms();
    } else {
      if (!this.timer) this.setTimer();
    }
  }

  /**
   * 将曝光的房间列表上传到后端接口
   */
  uploadExposureRooms(type) {
    reportRoomExposure({}, { room_ids: this.exposureRooms });
    this.exposureRooms = [];
    clearTimeout(this.timer);
    this.timer = null;
  }

  // 设置一个定时任务
  setTimer() {
    this.timer = setTimeout(() => {
      if (this.exposureRooms.length > 0) this.uploadExposureRooms();
    }, 60 * 1000);
  }

  initEventListener() {
    window.addEventListener("beforeunload", this.handleBeforeUnload.bind(this));
  }

  handleBeforeUnload() {
    if (this.exposureRooms.length > 0) this.uploadExposureRooms();
    this.observer.disconnect();
  }

  // 添加监听
  useObeserver(ele, val) {
    if (val) {
      ele._exposure_value = val;
      this.observer.observe(ele);
    }
  }

  unObeserver(ele) {
    this.observer.unobserve(ele);
  }
}

let exposureHandler;

function install(Vue, options) {
  exposureHandler = new ExposureHandler(options);
  Vue.directive("exposure", {
    bind: (el, binding) => {
      exposureHandler.useObeserver(el, binding.value);
    },
    unbind: (el) => {
      exposureHandler.unObeserver(el);
    },
  });
}
export default install;
